<template>
  <el-form ref="postForm" :model="postForm">
    <el-form-item>
      <el-select v-model="postForm.billing_id" placeholder="请选择兑换的课时" @change="fnSetSelect()">
        <el-option v-for="item in courseLists" :key="item.id" :label="item.key_name" :value="item.billing_id">
          <span :style="{'color':(item && item.price == 0) ? '#f56c6c':'#333333'}">{{ item.key_name }}(剩余{{ item.surplus }}) </span>
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-input-number v-model="postForm.transition_days" :min="0" :max="maxCourseNum" label="兑换课时数" />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="fnHandleSave()">确认兑换</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import Tool from '@/assets/js/tool.js'

const defaultForm = {
  billing_id: '',
  key: '',
  transition_days: 0
}

export default {
  name: 'ActiveExchangeCourse',
  props: {
    relationId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      postForm: Object.assign({}, defaultForm),
      listQuery: {
        relation_id: ''
      },
      maxCourseNum: 0,
      courseLists: []
    }
  },
  watch: {
    'relationId': function() {
      this.fnGetRecordLists()
    }
  },
  mounted: {

  },
  created() {
    this.fnGetRecordLists()
  },
  methods: {
    fnGetRecordLists() {
      this.listQuery.relation_id = this.relationId
      this.$http.getSubSellingValueList(this.listQuery).then(res => {
        if (res.code == 200) {
          this.courseLists = res.data
        }
      })
    },
    fnSetSelect() {
      if (this.postForm.billing_id) {
        var index = Tool.findIndexInArryByKeyVal(this.courseLists, 'billing_id', this.postForm.billing_id)
        this.maxCourseNum = parseInt(this.courseLists[index].surplus)
        this.postForm.key = this.courseLists[index].key
      }
    },
    fnHandleSave: function() {
      if (this.postForm.transition_days == 0) {
        this.$message.error('请输入兑换课时')
        return
      }
      this.$http.transitionSellingValue(this.postForm).then(res => {
        if (res.code == 200) {
          this.postForm.transition_days = 0
          this.postForm.billing_id = ''
          this.postForm.key = ''
          this.$emit('successCBK')
        }
      })
    }
  }
}
</script>
  <style lang="scss" scope>

  .combo-group {
    .tuolele-main-search {
      .el-button {
        margin-left:0px!important
      }
      .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
        padding-left: 20px !important;
      }
      .el-tabs--top .el-tabs__item.is-top:last-child {
        padding-right: 20px !important;
      }
      .el-form-item__label {
        font-size: 16px;
        color: #333;
      }
      .el-form-item__content {
        margin: 0 20px 0 12px;
      }
    }
  }
  </style>
